import { Box, Container, Grid, Typography, Button, useTheme } from '@mui/material';
import React from 'react';
const CategoriesPage = () => {
const theme = useTheme();
  const categories = [
    {
      title: 'Predatorrr',
      href: '/predator',
      color: '#063970' // Subtle salmon color
    },
    {
      title: 'Sea',
      href: '/sea',
      color: '#063970' // Light blue
    },
    {
      title: 'Carp',
      href: '/carp',
      color: '#063970' // Subtle green
    },
    {
      title: 'Course',
      href: '/course',
      color: '#063970' // Subtle orange
    }
  ];
  return (
    
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: 'url(/static/images/water-background.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        pt: 8
      }}
    >
      
      <Container maxWidth="lg">
        <Box sx={{ bgcolor: theme.palette.background.default, borderRadius: 2, p: 4, boxShadow: 3 }}>
          <Typography variant="h3" component="h1" align="center" gutterBottom>
            Fishing Categories
          </Typography>

          <Grid container spacing={4}>
            {categories.map((category) => (
              <Grid item xs={12} sm={6} md={3} key={category.title}>
                <Button
                  href={category.href}
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: category.color,
                    color: 'white',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    padding: '16px',
                    borderRadius: '12px',
                    '&:hover': {
                      backgroundColor: category.color,
                      opacity: 0.9
                    }
                  }}
                >
                  {category.title}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default CategoriesPage;
